<template>
  <div class="container" style="padding: 1rem; background-color: #f2f2f2">
    <div class="section" style="background-color: white; height: 100%">
      <!-- Titulo de la sección -->
      <div class="is-flex is-justify-content-flex-start">
        <h1 class="subtitle is-1 has-text-secondary">Gestión de Solicitudes</h1>
      </div>

      <!-- Separador -->
      <hr class="solid" />

      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(applyFilters)">
          <div class="columns is-vcentered px-5">
            <div class="column is-4">
              <b-field label="Búsqueda por Código">
                <ValidationProvider rules="" v-slot="{ errors }">
                  <b-input
                    v-model="request_id"
                    placeholder="Ej: SRC-15"
                  ></b-input>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>

            <div class="column is-4">
              <b-field label="Búsqueda por RUT">
                <ValidationProvider rules="runValidation" v-slot="{ errors }">
                  <b-input v-model="run" placeholder="Ej: 12345678-k"></b-input>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>

            <div class="column is-4">
              <b-field label="Búsqueda por Nombre">
                <ValidationProvider rules="" v-slot="{ errors }">
                  <b-input
                    v-model="fullname"
                    placeholder="Ingrese Nombre"
                  ></b-input>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
          </div>
          <div class="columns is-vcentered px-5">
            <!-- Request Type filter -->
            <div class="column">
              <b-field label="Búsqueda por Tipo de Solicitud">
                <multiselect
                  v-model="selectedRequestTypeOption"
                  :options="filteredRequestTypes"
                  :custom-label="
                    (opt) => requestTypes.find((x) => x.id === opt.id).real_name
                  "
                  :multiple="false"
                  placeholder="Seleccione un tipo de solicitud"
                  selectLabel=""
                  selectedLabel=""
                  deselectLabel=""
                  track-by="id"
                  label="name"
                  @search-change="updateSearch"
                  :internal-search="false"
                >
                  <template slot="singleLabel" slot-scope="props">
                    {{ props.option.real_name }}
                    <b-tag
                      v-if="props.option.role_type"
                      size="is-small is-secondary is-light"
                    >
                      <b>{{ props.option.role_type }}</b>
                    </b-tag>
                  </template>
                  <!-- Personalización de cómo se muestran las opciones -->
                  <template v-slot:option="{ option }">
                    <div class="tags">
                      <span class="mr-1">{{ option.real_name }}</span>
                      <b-tag
                        v-if="option.role_type"
                        size="is-small is-secondary is-light"
                      >
                        <b>{{ option.role_type }}</b>
                      </b-tag>
                    </div>
                  </template>
                  <template v-slot:noOptions> No existen datos</template>
                  <span slot="noResult"> No se encontraron elementos. </span>
                </multiselect>
              </b-field>
            </div>
            <div v-if="origins && origins.length > 1" class="column">
              <b-field label="Búsqueda por Módulo">
                <multiselect
                  v-model="selectedOrigin"
                  :options="origins"
                  :multiple="false"
                  placeholder="Seleccione un tipo de solicitud"
                  selectLabel=""
                  selectedLabel=""
                  deselectLabel=""
                >
                </multiselect>
              </b-field>
            </div>
          </div>
          <!-- Filtros de búsqueda -->
          <div class="columns is-vcentered px-5">
            <div class="column">
              <b-collapse
                class="card"
                animation="slide"
                :open="isOpen"
                :aria-id="'contentIdForA11y5'"
              >
                <template #trigger="props">
                  <div
                    class="card-header"
                    role="button"
                    :aria-controls="'contentIdForA11y5'"
                    :aria-expanded="props.open"
                  >
                    <p
                      class="card-header-title is-flex is-justify-content-left subtitle is-3-desktop is-5-mobile has-text-secondary has-text-weight-bold is-family-secondary my-2"
                    >
                      <b-icon icon="sliders-h" class="mr-2" />
                      Más Filtros de Búsqueda
                    </p>
                    <a class="card-header-icon">
                      <b-icon
                        :icon="props.open ? 'minus-circle' : 'plus-circle'"
                        type="is-secondary"
                        size="is-medium"
                      >
                      </b-icon>
                    </a>
                  </div>
                </template>

                <div class="card-content columns is-multiline">
                  <!-- Progress filter -->
                  <div class="column is-6">
                    <b-field label="Búsqueda por Estado">
                      <multiselect
                        v-model="selectedProgressOption"
                        :options="progress"
                        :custom-label="
                          (opt) => progress.find((x) => x.id === opt.id).name
                        "
                        :multiple="false"
                        placeholder="Seleccione un estado"
                        selectLabel="Presione para seleccionar"
                        selectedLabel="Seleccionado"
                        deselectLabel="Presione para deseleccionar"
                        track-by="id"
                        label="name"
                      >
                        <template v-slot:noOptions> No existen datos</template>
                        <span slot="noResult">
                          No se encontraron elementos.
                        </span>
                      </multiselect>
                    </b-field>
                  </div>

                  <!-- Unit filter -->
                  <div class="column is-6">
                    <b-field label="Búsqueda por Unidad">
                      <multiselect
                        v-model="selectedUnitOption"
                        :options="units"
                        :custom-label="
                          (opt) => units.find((x) => x.id === opt.id).name
                        "
                        :multiple="false"
                        placeholder="Seleccione una unidad"
                        selectLabel="Presione para seleccionar"
                        selectedLabel="Seleccionado"
                        deselectLabel="Presione para deseleccionar"
                        track-by="id"
                        label="name"
                      >
                        <template v-slot:noOptions> No existen datos</template>
                        <span slot="noResult">
                          No se encontraron elementos.
                        </span>
                      </multiselect>
                    </b-field>
                  </div>

                  <!-- StartDate filter -->
                  <div class="column is-half">
                    <b-field label="Búsqueda por Fecha desde">
                      <b-datepicker
                        placeholder="Selecciona una Fecha"
                        icon="calendar-alt"
                        trap-focus
                        v-model="selectedStartDate"
                        :icon-right="selectedStartDate ? 'close-circle' : ''"
                        icon-right-clickable
                        @icon-right-click="clearStartDate"
                        :date-formatter="
                          (date) => date.toLocaleDateString('es-ES')
                        "
                        locale="es"
                      >
                      </b-datepicker>
                    </b-field>
                  </div>

                  <!-- EndDate filter -->
                  <div class="column is-half">
                    <b-field label="Búsqueda por Fecha hasta">
                      <b-datepicker
                        placeholder="Selecciona una Fecha"
                        icon="calendar-alt"
                        icon-pack="fas"
                        trap-focus
                        v-model="selectedEndDate"
                        :icon-right="selectedEndDate ? 'close-circle' : ''"
                        icon-right-clickable
                        @icon-right-click="clearEndDate"
                        :date-formatter="
                          (date) => date.toLocaleDateString('es-ES')
                        "
                        locale="es"
                      >
                      </b-datepicker>
                    </b-field>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>

          <div class="level-right buttons px-5">
            <b-button
              type="is-warning"
              icon-left="eraser"
              @click="clearFilters"
            >
              Limpiar Filtros de Búsqueda
            </b-button>
            <b-button type="is-primary" icon-left="sync" native-type="submit">
              Recargar Solicitudes
            </b-button>
            <b-button
              native-type="submit"
              type="is-secondary"
              icon-left="search"
              >Buscar
            </b-button>
          </div>

          <!--Iconografía-->
          <div class="columns is-vcentered px-5">
            <div class="column">
              <b-collapse
                class="card"
                animation="slide"
                :open="isOpen"
                :aria-id="'contentIdForA11y5'"
              >
                <template #trigger="props">
                  <div
                    class="card-header"
                    role="button"
                    :aria-controls="'contentIdForA11y5'"
                    :aria-expanded="props.open"
                  >
                    <p
                      class="card-header-title is-flex is-justify-content-left subtitle is-3-desktop is-5-mobile has-text-secondary has-text-weight-bold is-family-secondary my-2"
                    >
                      <b-icon class="mr-2" icon="info-circle"> </b-icon>
                      Iconografía
                    </p>
                    <a class="card-header-icon">
                      <b-icon
                        :icon="props.open ? 'minus-circle' : 'plus-circle'"
                        type="is-secondary"
                        size="is-medium"
                      >
                      </b-icon>
                    </a>
                  </div>
                </template>

                <div class="card-content">
                  <div class="columns is-multiline is-vcentered">
                    <div class="column is-full">
                      <p class="title">Acciones</p>
                    </div>
                    <div class="column is-full">
                      <b-button
                        class="mr-1 is-info is-light is-border-cornflowerblue"
                      >
                        <b-icon type="is-secondary" icon="eye" size="is-medium">
                        </b-icon> </b-button
                      >Ver: Permite ver y solo ver los detalles de la solicitud.
                    </div>
                    <div class="column is-full">
                      <b-button
                        class="mr-1 is-primary is-light is-border-orange"
                      >
                        <b-icon
                          type="is-primary"
                          icon="file-signature"
                          size="is-medium"
                        >
                        </b-icon>
                      </b-button>
                      Asignar Paso: Permite asignarse un paso para poder añadir
                      observaciones, revisar documentación o cambiar el estado
                      de una solicitud.
                    </div>
                    <div class="column is-full">
                      <b-button
                        class="mr-1 is-success is-light is-border-darkgreen"
                      >
                        <b-icon
                          type="is-green"
                          icon="file-signature"
                          size="is-medium"
                        ></b-icon>
                      </b-button>
                      Revisar paso: Permite entrar a revisar el paso actual de
                      una solicitud. Esta acción esta disponible una vez se ha
                      asignado un paso y es usted la persona asignada.
                    </div>
                    <div class="column is-full">
                      <b-button
                        class="mr-1 is-danger is-light is-border-darkred"
                      >
                        <b-icon
                          type="is-danger"
                          icon="file-signature"
                          size="is-medium"
                        ></b-icon>
                      </b-button>
                      Paso en revisión: Esta es una solicitud que ya se
                      encuentra en revisión por otra persona y permite ver el
                      revisor actual del paso e ingresar a revisar esta
                      solicitud.
                    </div>

                    <div class="column is-full">
                      <b-icon
                        type="is-secondary"
                        icon="arrow-circle-right"
                        size="is-medium"
                      ></b-icon>
                      Ver información del paso de la solicitud.
                    </div>
                    <div class="column is-full">
                      <p class="title">Estados</p>
                    </div>
                    <div class="column is-full">
                      <b-tag :class="PROGRESSES['Enviada'].color">
                        <b-icon
                          :icon="PROGRESSES['Enviada'].icon"
                          class="mr-1"
                        ></b-icon
                        >Enviada
                      </b-tag>
                      {{
                        getProgressFromId(PROGRESSES["Enviada"].id)
                          ? getProgressFromId(PROGRESSES["Enviada"].id)
                              .description
                          : ""
                      }}
                    </div>
                    <template v-for="(state, key, index) of PROGRESSES">
                      <div
                        v-if="index > 0 && state.id !== 9"
                        class="column is-half"
                      >
                        <b-tag :class="state.color">
                          <b-icon :icon="state.icon" class="mr-1"> </b-icon
                          >{{ key }}
                        </b-tag>
                        {{
                          getProgressFromId(state.id)
                            ? getProgressFromId(state.id).description
                            : ""
                        }}
                      </div>
                      <div v-else-if="state.id === 9" class="column is-half">
                        <b-tag :class="state.color">
                          <b-icon
                            icon-pack="far"
                            :icon="state.icon"
                            class="mr-1"
                          >
                          </b-icon
                          >{{ key }}
                        </b-tag>
                        {{
                          getProgressFromId(state.id)
                            ? getProgressFromId(state.id).description
                            : ""
                        }}
                      </div>
                    </template>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </form>
      </ValidationObserver>

      <!-- Separator -->
      <hr class="solid" />
      <b-tabs
        v-if="requests"
        v-model="selectedTab"
        @input="selectProgress()"
        position="is-centered"
        class="block mb-0 pb-0"
        :multiline="true"
      >
        <b-tab-item value="-3">
          <template #header>
            <span class="tab-header">
              <b-icon icon="star"></b-icon>
              Prioritarias
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="0">
          <template #header>
            <span class="tab-header">
              <b-icon icon="list"></b-icon>
              Todas
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="-5">
          <template #header>
            <span class="tab-header">
              <b-icon icon="user-edit"></b-icon>
              Esperando mi revisión
              <span
                v-if="tabCount"
                :class="{
                  'notification-circle': true,
                  'ml-1': true,
                  'has-background-secondary': selectedTab === '-5',
                  'has-background-info': selectedTab !== '-5',
                }"
              >
                <b class="has-text-white">
                  {{ getTabCount("waiting_my_review") }}
                </b>
              </span>
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="-4">
          <template #header>
            <span class="tab-header">
              <b-icon icon="comments"></b-icon>
              Detenciones respondidas
              <span
                v-if="tabCount"
                :class="{
                  'notification-circle': true,
                  'ml-1': true,
                  'has-background-secondary': selectedTab === '-4',
                  'has-background-info': selectedTab !== '-4',
                }"
              >
                <b class="has-text-white">
                  {{ getTabCount("stopped_responded") }}
                </b>
              </span>
            </span>
          </template>
        </b-tab-item>

        <b-tab-item value="-2">
          <template #header>
            <span class="tab-header">
              <b-icon icon="exclamation-triangle"></b-icon>
              Vencidas
              <span
                v-if="tabCount"
                :class="{
                  'notification-circle': true,
                  'ml-1': true,
                  'has-background-secondary': selectedTab === '-2',
                  'has-background-danger': selectedTab !== '-2',
                }"
              >
                <b class="has-text-white">
                  {{ getTabCount("overdue") }}
                </b>
              </span>
            </span>
          </template>
        </b-tab-item>

        <b-tab-item value="-1">
          <template #header>
            <span class="tab-header">
              <b-icon icon="stopwatch"></b-icon>
              Por Vencer
              <span
                v-if="tabCount"
                :class="{
                  'notification-circle': true,
                  'ml-1': true,
                  'has-background-secondary': selectedTab === '-1',
                  'has-background-grey': selectedTab !== '-1',
                }"
              >
                <b class="has-text-white">
                  {{ getTabCount("close_overdue") }}
                </b>
              </span>
            </span>
          </template>
        </b-tab-item>

        <b-tab-item value="4">
          <template #header>
            <span class="tab-header">
              <b-icon icon="stop"></b-icon>
              Detenidas
              <span
                v-if="tabCount"
                :class="{
                  'notification-circle': true,
                  'ml-1': true,
                  'has-background-secondary': selectedTab === '4',
                  'has-background-warning': selectedTab !== '4',
                }"
              >
                <b class="has-text-white">
                  {{ getTabCount("stopped") }}
                </b>
              </span>
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="2">
          <template #header>
            <span class="tab-header">
              <b-icon icon="clock"></b-icon>
              En Curso
              <span
                v-if="tabCount"
                :class="{
                  'notification-circle': true,
                  'ml-1': true,
                  'has-background-secondary': true,
                }"
              >
                <b class="has-text-white">
                  {{ getTabCount("in_progress") }}
                </b>
              </span>
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="5">
          <template #header>
            <span class="tab-header">
              <b-icon icon="paper-plane"></b-icon>
              Enviadas
              <span
                v-if="tabCount"
                :class="{
                  'notification-circle': true,
                  'ml-1': true,
                  'has-background-secondary': selectedTab === '5',
                  'has-background-primary': selectedTab !== '5',
                }"
              >
                <b class="has-text-white">
                  {{ getTabCount("sent") }}
                </b>
              </span>
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="6">
          <template #header>
            <span class="tab-header">
              <b-icon icon="check-double"></b-icon>
              Aceptadas
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="7">
          <template #header>
            <span class="tab-header">
              <b-icon icon="times"></b-icon>
              Rechazadas
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="8">
          <template #header>
            <span class="tab-header">
              <b-icon icon="user-times"></b-icon>
              Desistidas
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="9">
          <template #header>
            <span class="tab-header">
              <b-icon icon="file-excel"></b-icon>
              No Corresponden
            </span>
          </template>
        </b-tab-item>
        <b-tab-item value="10">
          <template #header>
            <span class="tab-header">
              <b-icon icon="comment-slash"></b-icon>
              No Procesadas
            </span>
          </template>
        </b-tab-item>
      </b-tabs>

      <table-list-requests
        v-if="!isLoading || totalRequests != null"
        :applicant_information="true"
        :actions="true"
        :requests="requests"
        :backend-pagination="true"
        :total-requests="totalRequests"
        @pageChange="onPageChange"
        :loading="isLoading"
        :can-review-request="canReviewRequest"
      ></table-list-requests>
    </div>
    <b-loading
      :is-full-page="true"
      v-model="isLoadingAny"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import axios from "axios";
import TableListRequests from "./TableListRequests";
import moment from "moment";
import { extend } from "vee-validate";
import { PROGRESSES } from "../../packs/utilities";
import _ from "lodash";

extend("runValidation", {
  validate(value, args) {
    return /^\d+(?:-\d+)?(?:-[1-9k])?$/i.test(value);
  },
  message: "Ingrese un run válido, por favor",
});
export default {
  name: "ListRequests",
  computed: {
    PROGRESSES() {
      return PROGRESSES;
    },
    isLoadingAny() {
      return this.isLoading || this.isLoadingAll;
    },
    filteredRequestTypes() {
      if (!this.searchRequestType) return this.requestTypes;

      const normalizedSearch = this.normalizeString(this.searchRequestType);
      return this.requestTypes.filter((option) => {
        const normalizedOption = this.normalizeString(option.name || "");
        return normalizedOption.includes(normalizedSearch);
      });
    },
    // Computed para optimizar acceso a tab counts
    getTabCount() {
      return (tabName) => this.tabCount?.[tabName] || 0;
    },
    // Computed para optimizar cálculo de páginas
    frontendPageSize() {
      return 10;
    },
    calculateBackendPage() {
      return Math.floor(
        (this.backendPage - 1) / (this.backendPerPage / this.frontendPageSize) +
          1
      );
    },
  },
  props: ["canReviewRequest"],
  components: {
    TableListRequests,
  },
  data: function () {
    return {
      fullname: "",
      //Filters Options and Selected Variables
      states: [
        "",
        "Depto. Académico",
        "Secretaria FING",
        "Secretaria Académica",
        "Decano",
      ],
      progress: [],
      selectedProgressOption: null,
      selectedStateOption: null,
      units: [],
      selectedUnitOption: null,
      requestTypes: [],
      selectedRequestTypeOption: null,
      selectedStartDate: null,
      selectedEndDate: null,
      isLoading: true,
      isLoadingAll: false,
      requests: [],
      selectedTab: "0",
      run: "",
      overdue: false,
      close_overdue: false,
      priority: false,
      pending_appeal: false,
      request_id: null,
      isOpen: false,
      backendPage: 1,
      backendPerPage: 10,
      loadedPages: [],
      totalRequests: null,
      origens: null,
      codeSent: null,
      fullnameSent: "",
      runSent: "",
      stateSent: null,
      unitSent: null,
      requestTypeSent: null,
      startDateSent: null,
      endDateSent: null,
      progressSent: null,
      searchRequestType: "",
      waiting_my_review: false,
      requestStructure: {
        id: 0,
        code: "-",
        request_state_reviewer: "-",
        reviewer_name: "-",
        applicant: "-",
        run: "-",
        request_type: "-",
        unit: "-",
        progress_of_request: "Enviada",
        start_date: null,
        end_date: null,
        state: "-",
        state_information: "-",
        description: "-",
        request_state_id: null,
        request_states: [],
      },

      tabCount: null,
      selectedOrigin: null,
      origins: null,
    };
  },

  created() {
    document.title = "Listado de solicitudes";
    this.fetchFilterDataAndRequests();
  },

  methods: {
    fetchFilterDataAndRequests() {
      let vm = this;
      vm.isLoadingAll = true;
      axios
        .all([
          axios.get("/progresses.json").then((response) => {
            vm.progress = response.data;
          }),
          axios.get("/units.json").then((response) => {
            vm.units = response.data;
          }),
          axios.get("/request_types.json").then((response) => {
            vm.requestTypes = response.data.map((item) => {
              if (
                item.role_type === "No Titulado" ||
                item.role_type === "Titulado"
              ) {
                item.role_type = `Pregrado`;
              }
              return item;
            });
            vm.requestTypes = _.uniqBy(
              response.data,
              (item) => `${item.real_name}-${item.role_type}`
            );
            const nombresPorSigla = {
              SRC: "Solicitudes de registro curricular",
              MSD: "Solicitudes Docentes",
              MSA: "Módulo Secretaría Académica",
            };

            this.origins = [
              ...new Set(vm.requestTypes.map((obj) => obj.origin)),
            ].map((sigla) => nombresPorSigla[sigla]);
          }),
          this.applyFilters(),
        ])
        .catch((error) => {
          console.error(error);
        });
      //.finally(() => (vm.isLoadingAll = false));
      //this.fetchTabCount();
    },
    async fetchTabCount() {
      try {
        const response = await axios.get("/requests/tab-count.json");
        this.tabCount = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoadingAll = false;
      }
    },
    async fetchRequests() {
      this.isLoading = true;
      const params = {
        page: this.calculateBackendPage,
        per_page: this.backendPerPage,
      };

      try {
        const response = await axios.get("/requests.json", { params });
        this.totalRequests = response.data.total_requests;
        this.mapRequests(response.data.requests);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    getProgressFromId(id) {
      return this.progress.find((x) => x.id === id) || null;
    },
    generateName(opt) {
      let requestType = this.requestTypes.find((x) => x.id === opt.id);
    },

    runValidation() {
      return [
        (value) => {
          if (!/^d+(?:-d+)?(?:-[1-9k])?$/.test(value)) {
            return "Por favor,ingrese un run válido.";
          }
          return true;
        },
      ];
    },
    selectProgress() {
      this.resetPaginationState();
      let option = parseInt(this.selectedTab, 10);
      this.overdue = false;
      this.priority = false;
      this.close_overdue = false;
      this.pending_appeal = false;
      this.waiting_my_review = false;
      this.selectedProgressOption = null;
      if (option >= 0) {
        this.selectedProgressOption = this.progress.find(
          (x) => x.id === parseInt(this.selectedTab, 10)
        );
      } else {
        switch (option) {
          case -2:
            this.overdue = true;
            break;
          case -1:
            this.close_overdue = true;
            break;
          case -3:
            this.priority = true;
            break;
          case -4:
            this.pending_appeal = true;
            break;
          case -5:
            this.waiting_my_review = true;
            break;
        }
      }
      this.applyFilters();
    },

    hasNewFilters() {
      return (
        this.codeSent !== this.request_id ||
        this.fullnameSent !== this.fullname ||
        this.runSent !== this.run ||
        this.unitSent !== this.selectedUnitOption ||
        this.requestTypeSent !== this.selectedRequestTypeOption ||
        this.startDateSent !== this.selectedStartDate ||
        this.endDateSent !== this.selectedEndDate ||
        this.progressSent !== this.selectedProgressOption
      );
    },

    storeSentFilters() {
      this.codeSent = this.request_id;
      this.fullnameSent = this.fullname;
      this.runSent = this.run;
      this.unitSent = this.selectedUnitOption;
      this.requestTypeSent = this.selectedRequestTypeOption;
      this.startDateSent = this.selectedStartDate;
      this.endDateSent = this.selectedEndDate;
      this.progressSent = this.selectedProgressOption;
    },

    applyFilters() {
      this.isLoadingAll = true;
      axios
        .all([this.fetchRequestsFiltered()])
        .finally(() => (this.isLoadingAll = false));
      this.fetchTabCount();
    },

    async fetchRequestsFiltered() {
      this.isLoading = true;

      if (this.hasNewFilters()) {
        this.resetPaginationState();
      }
      this.storeSentFilters();

      const formatDate = (date) => {
        if (!date) return null;
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      };

      const params = {
        request_id: this.request_id,
        progress_id: this.selectedProgressOption?.id || null,
        unit_id: this.selectedUnitOption?.id || null,
        request_type_id: this.selectedRequestTypeOption?.id || null,
        start_date: formatDate(this.selectedStartDate),
        end_date: formatDate(this.selectedEndDate),
        run: this.run || null,
        fullname: this.fullname,
        close_overdue: this.close_overdue,
        overdue: this.overdue,
        priority: this.priority,
        pending_appeal: this.pending_appeal,
        page: this.calculateBackendPage,
        per_page: this.backendPerPage,
        waiting_my_review: this.waiting_my_review,
        origin: this.selectedOrigin || null,
      };

      try {
        const response = await axios.get("/requests/apply-filters.json", {
          params,
        });
        this.totalRequests = response.data.total_requests;
        this.mapRequests(response.data.requests);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    clearStartDate() {
      this.selectedStartDate = null;
    },
    clearEndDate() {
      this.selectedEndDate = null;
    },
    onPageChange(page) {
      this.backendPage = page;

      // Verificar si los datos de esta página ya están cargados en el array requests
      const pageStartIndex = (page - 1) * this.frontendPageSize;
      const pageEndIndex = pageStartIndex + this.frontendPageSize;

      // Verificar si todos los elementos de esta página están cargados y no son estructuras vacías
      const pageHasData = this.requests
        .slice(pageStartIndex, pageEndIndex)
        .every(
          (request) =>
            request && request !== this.requestStructure && request.id !== 0
        );

      // Solo aplicar filtros si la página no tiene datos cargados
      if (!pageHasData) {
        this.applyFilters();
      }
    },

    reorderAllBackendPages(newBackendPageIndex, newBackendPage) {
      let newRequests = Array(this.totalRequests).fill(this.requestStructure);
      newRequests.forEach((request, index) => {
        return;
      });
    },
    removeLastRepetitions() {
      const seenIds = new Set();
      const uniqueRequests = [];

      for (const request of this.requests) {
        // Si es la estructura base, la mantenemos
        if (request === this.requestStructure || request.id === 0) {
          uniqueRequests.push(request);
        } else if (!seenIds.has(request.id)) {
          seenIds.add(request.id);
          uniqueRequests.push(request);
        }
      }

      this.requests = uniqueRequests;
    },

    mapRequests(requests) {
      const backendPage = this.calculateBackendPage;

      // Inicializar array si está vacío
      if (this.requests.length === 0) {
        this.requests = Array(this.totalRequests).fill(this.requestStructure);
      }

      // Ajustar tamaño si disminuyó y estamos en la última página
      if (
        this.requests.length > this.totalRequests &&
        backendPage === Math.ceil(this.totalRequests / this.frontendPageSize)
      ) {
        this.requests = this.requests.slice(0, this.totalRequests);
      }

      // Asignar solicitudes a posiciones correspondientes
      const startIndex = (backendPage - 1) * this.backendPerPage;
      requests.forEach((request, index) => {
        // Normalizar fechas directamente al asignar
        if (
          request !== this.requestStructure &&
          request.start_date?.includes("T")
        ) {
          request.start_date = moment(
            request.start_date,
            "YYYY-MM-DD HH:mm:ss"
          ).format("DD-MM-YYYY");
          request.end_date = request.end_date
            ? moment(request.end_date, "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY"
              )
            : null;
        }
        this.requests[startIndex + index] = request;
      });

      // Remover duplicaciones después de asignar
      this.removeLastRepetitions();

      // Actualizar páginas cargadas - solo agregar las páginas del frontend que se llenaron con datos reales
      const pagesPerBackendPage = this.backendPerPage / this.frontendPageSize;
      const newPages = [];

      for (let i = 0; i < pagesPerBackendPage; i++) {
        const frontendPage = (backendPage - 1) * pagesPerBackendPage + i + 1;
        const maxPage = Math.ceil(this.totalRequests / this.frontendPageSize);

        if (frontendPage <= maxPage) {
          // Verificar que esta página del frontend tiene datos reales
          const pageStartIndex = (frontendPage - 1) * this.frontendPageSize;
          const pageEndIndex = Math.min(
            pageStartIndex + this.frontendPageSize,
            this.totalRequests
          );
          const hasRealData = this.requests
            .slice(pageStartIndex, pageEndIndex)
            .some(
              (request) =>
                request && request !== this.requestStructure && request.id !== 0
            );

          if (hasRealData && !this.loadedPages.includes(frontendPage)) {
            newPages.push(frontendPage);
          }
        }
      }

      this.loadedPages = [...this.loadedPages, ...newPages];
    },
    normalizeString(str) {
      if (!str) return "";
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase();
    },

    resetPaginationState() {
      this.backendPage = 1;
      this.loadedPages = [];
      this.requests = [];
      this.totalRequests = null;
    },

    updateSearch(search) {
      this.searchRequestType = search;
    },
    clearFilters() {
      this.request_id = null;
      this.run = "";
      this.fullname = "";
      this.selectedRequestTypeOption = null;
      this.selectedProgressOption = null;
      this.selectedUnitOption = null;
      this.selectedStartDate = null;
      this.selectedEndDate = null;
      this.selectedTab = "0";
      this.overdue = false;
      this.close_overdue = false;
      this.priority = false;
      this.pending_appeal = false;
      this.waiting_my_review = false;
      this.resetPaginationState();
      this.applyFilters();
    },
  },
};
</script>

<style scoped>
.notification-circle {
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  min-width: 1.45em;
  min-height: 1em;
}
</style>
